<template>
  <div
    class="tw-absolute tw-bottom-0 tw-h-full tw-w-full tw-overflow-hidden"
    :class="[
      isOpen ? 'tw-pointer-events-auto' : 'tw-pointer-events-none',
    ]"
  >
    <div
      class="tw-relative tw-bg-white/50 tw-h-full tw-w-full tw-z-20 tw-ease-out tw-duration-300 tw-cursor-pointer"
      :class="[
        isOpen ? 'tw-opacity-100' : 'tw-opacity-0',
      ]"
      @click="$emit('close')"
    />
    <div
      class="tw-w-full tw-absolute tw-z-30 tw-ease-out tw-duration-300 tw-rounded-t-3xl tw-overflow-hidden"
      :class="[
        isOpen ? 'tw-translate-y-0 tw-bottom-0' : 'tw-bottom-0 tw-translate-y-full',
      ]"
    >
      <div class="tw-flex tw-flex-col tw-w-full tw-bg-white">
        <div class="tw-flex tw-items-center tw-justify-between tw-bg-light tw-p-6">
          <h2 class="tw-leading-7 tw-tracking-wide">
            {{ $t('messaging.new_thread') }}
          </h2>
          <i-button
            type="white"
            size="medium"
            is-icon
            @click="$emit('close')"
          >
            <icon-close />
          </i-button>
        </div>
        <div class="tw-flex tw-flex-col tw-px-6 tw-mt-2 tw-mb-6">
          <template
            v-for="(permit, index) in canBeOpenedThreads"
            :key="permit.id"
          >
            <div
              v-if="index !== 0"
              class="tw-bg-gray tw-w-full tw-h-px tw-my-2"
            />
            <ForeignersNewThreadItem
              :permit="permit"
              :store-path="storePath"
              @new-thread="$emit('close')"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForeignersNewThreadItem from '@/components/Foreigners/Messaging/ForeignersNewThreadItem.vue';

export default {
  name: 'ForeignersNewThreadDrawer',
  components: { ForeignersNewThreadItem },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    canBeOpenedThreads: {
      type: Array,
      default: () => [],
    },
    storePath: {
      type: String,
      required: true,
    },
  },
};
</script>
